// extracted by mini-css-extract-plugin
export default {"container":"FloorChangedPopup_container__Obmmw","icon":"FloorChangedPopup_icon__1dHHD"};